import React from 'react';
import { Radio } from 'antd';
import { RadioChangeEvent } from 'antd/es/radio';
import { EStoreScopeType, storeScopeTypeLabel } from 'entities/Permission/Permission.models';

interface IComponentProps {
  value?: EStoreScopeType;
  onChange?: (type: EStoreScopeType) => void;
  disabled?: boolean;
}

// Scope-type radio for a franchisor user's store scope. Split from the ids picker so each can sit in
// its own Form.Item and get its own validation error.
export const StoreScopeTypeSelector: React.FC<IComponentProps> = ({ value, onChange, disabled }) => {
  const handleChange = (e: RadioChangeEvent) => {
    onChange?.(e.target.value);
  };

  return (
    <Radio.Group value={value} onChange={handleChange} disabled={disabled}>
      <Radio value={EStoreScopeType.All}>{storeScopeTypeLabel[EStoreScopeType.All]}</Radio>
      <Radio value={EStoreScopeType.Region}>{storeScopeTypeLabel[EStoreScopeType.Region]}</Radio>
      <Radio value={EStoreScopeType.Group}>{storeScopeTypeLabel[EStoreScopeType.Group]}</Radio>
      <Radio value={EStoreScopeType.Stores}>{storeScopeTypeLabel[EStoreScopeType.Stores]}</Radio>
    </Radio.Group>
  );
};
